import React from "react";
import "./styles/SearchBar.css";

/**
 * F3 — debounced search input (App owns the raw query; the debounced
 * value drives the actual filtering).
 */
export default function SearchBar({ value, onChange, placeholder = "Search coins…" }) {
  return (
    <div className="search-bar" role="search">
      <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">
        <circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
        <line x1="15.5" y1="15.5" x2="21" y2="21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <input
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Search coins by name or symbol"
        data-testid="search-input"
      />
    </div>
  );
}
